export const chainMarketProtocols = ['aave', 'benqi', 'seamless'];
export const protocols = [...chainMarketProtocols, 'venus'] as const;

export type Protocol = typeof protocols[number];
